import api from './api';

export const storageService = {
  getMetrics: async () => {
    const response = await api.get('/storage/metrics');
    return response.data;
  },

  triggerBackfill: async () => {
    const response = await api.post('/storage/backfill');
    return response.data;
  },
};

export default storageService;
